import { render, staticRenderFns } from "./OtherComment.vue?vue&type=template&id=6070e408"
import script from "./OtherComment.vue?vue&type=script&lang=js"
export * from "./OtherComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports